import { render, staticRenderFns } from "./TabelaTags.vue?vue&type=template&id=2e9d72d4"
import script from "./TabelaTags.vue?vue&type=script&lang=js"
export * from "./TabelaTags.vue?vue&type=script&lang=js"
import style0 from "./TabelaTags.vue?vue&type=style&index=0&id=2e9d72d4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports